<template>
    <div>
        <zm-row>
            Path: <zm-select v-model="path.namespace" class="select-inline" placeholder="namespace" filterable clearable
            @change="setNamespace" popper-class="select-popper">
                <zm-option v-for="item in namespaceList" :key="item" :value="item"></zm-option>
            </zm-select>
            <zm-select v-model="path.applicationId" placeholder="Application" filterable clearable @change="handelAppChange()"
                class="select-inline" popper-class="select-popper" :width-limit="{ disableTip: true }">
                <zm-option v-for="item in applicationList" :key="item.id" :label="item.applicationName" :value="item.id"></zm-option>
            </zm-select>
            <zm-select v-for="(item, index) in path.prefixPath" :key="index" v-model="path.prefixPath[index]" filterable clearable
                @change="handlePrefixChange(index, true)" class="select-inline">
                <zm-option v-for="item in pathList[index]" :key="item.id" :label="item.path" :value="item.path"></zm-option>
            </zm-select>
            <!-- <zm-input v-model="path.path" style="width: 200px" @keyup.enter.native="fetchData"></zm-input> -->
            InstanceId: <zm-input v-model="filter.instanceId" style="width: 200px" @keyup.enter.native="fetchData"></zm-input>
            <zm-button type="icon" icon="zm-icon-search" @click="fetchData" class="btn-in-line"></zm-button>
        </zm-row>
        <div class="table-container">
            <zm-table :data="[{}]" v-if="!(list[0] && Object.keys(list[0]).length)" class="header-table">
                <zm-table-column type="selection"></zm-table-column>
                <zm-table-column type="index" width="50px"></zm-table-column>
                <zm-table-column prop="path" label="path"></zm-table-column>
                <zm-table-column prop="instanceId" label="instanceId"></zm-table-column>
                <zm-table-column prop="region" label="region" width="180px"></zm-table-column>
                <zm-table-column prop="result" label="result" width="120px">
                    <!-- eslint-disable-next-line -->
                    <template slot="header" slot-scope="scope">
                        <zm-dropdown trigger="click" @command="handleCommand">
                            <span class="zm-dropdown-link">
                                result<i class="zm-icon-down zm-icon--right"></i>
                            </span>
                            <zm-dropdown-menu slot="dropdown">
                                <zm-dropdown-item command="">All</zm-dropdown-item>
                                <zm-dropdown-item command="true">True</zm-dropdown-item>
                                <zm-dropdown-item command="false">False</zm-dropdown-item>
                            </zm-dropdown-menu>
                        </zm-dropdown>
                    </template>
                </zm-table-column>
                <zm-table-column width="120px"></zm-table-column>
            </zm-table>
            <zm-table :data="list" v-loading="loading" @selection-change="handleSelectionChange">
                <zm-table-column type="selection" :selectable="selectPermission"></zm-table-column>
                <zm-table-column type="index" width="50px"></zm-table-column>
                <zm-table-column prop="path" label="path"></zm-table-column>
                <zm-table-column prop="instanceId" label="instanceId"></zm-table-column>
                <zm-table-column prop="region" label="region" width="180px"></zm-table-column>
                <zm-table-column prop="result" label="result" width="120px" align="center">
                    <!-- eslint-disable-next-line -->
                    <template slot="header" slot-scope="scope">
                        <zm-dropdown trigger="click" @command="handleCommand">
                            <span class="zm-dropdown-link">
                                result<i class="zm-icon-down zm-icon--right"></i>
                            </span>
                            <zm-dropdown-menu slot="dropdown">
                                <zm-dropdown-item command="">All</zm-dropdown-item>
                                <zm-dropdown-item command="true">True</zm-dropdown-item>
                                <zm-dropdown-item command="false">False</zm-dropdown-item>
                            </zm-dropdown-menu>
                        </zm-dropdown>
                    </template>
                    <template slot-scope="scope">
                        <i :class="scope.row.result ? 'zm-icon-ok' : 'zm-icon-close'"></i>
                    </template>
                </zm-table-column>
                <zm-table-column width="120px" align="right">
                    <!-- eslint-disable-next-line -->
                    <template slot="header" slot-scope="scope">
                        <zm-button size="small" type="icon" icon="zm-icon-refresh" v-if="batchPermission"
                            title="batch retry instance" @click="batchRetryInstance()"></zm-button>
                        <!-- <zm-button size="small" type="icon" icon="zm-icon-play-circle-outline"
                            title="batch check instance" @click="batchCheckInstance()"></zm-button> -->
                        <zm-button size="small" type="icon" icon="zm-icon-delete" v-if="batchPermission"
                            title="batch unregister instance" @click="batchUnregisterInstance()"></zm-button>
                    </template>
                    <template slot-scope="scope">
                        <zm-button size="small" type="icon" icon="zm-icon-refresh" v-if="buttonPermission(scope.row.applicationId)"
                            title="retry instance" @click="retryInstance(scope.row.instanceId)"></zm-button>
                        <!-- <zm-button size="small" type="icon" icon="zm-icon-play-circle-outline"
                            title="check instance" @click="checkInstance(scope.row.instanceId)"></zm-button> -->
                        <zm-button size="small" type="icon" icon="zm-icon-delete" v-if="buttonPermission(scope.row.applicationId)"
                            title="unregister instance" @click="unregisterInstance(scope.row.instanceId)"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap">
                <zm-pagination @current-change="fetchData"
                    @size-change="handleSizeChange"
                    :current-page.sync="filter.pageNo"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="filter.pageSize"
                    layout="sizes, total, prev, pager, next, jumper"
                    :total="total">
                </zm-pagination>
            </div>
        </div>
        <zm-dialog title="Failed List" :visible.sync="failedVisible" show-close>
            <div class="table-container">
                <zm-table :data="failedList">
                    <zm-table-column prop="instanceId" label="Instance Id" show-overflow-tooltip></zm-table-column>
                    <zm-table-column prop="message" label="Message" show-overflow-tooltip></zm-table-column>
                </zm-table>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { listNamespace, listApplication, listPath, listInstance, retryInstance, checkInstance, unregisterInstance } from '@/api/index'
import { getPermission } from '@/api/permission'
export default {
    name: 'instance',
    data () {
        return {
            permission: {
                isSuperAdmin: false,
                isSuperOperator: false,
                manageableResources: []
            },
            list: [],
            selectedRows: [],
            total: 0,
            loading: false,
            namespaceList: [],
            applicationList: [],
            pathList: [[]],
            path: {
                namespace: '',
                application: '',
                applicationId: '',
                prefixPath: []
            },
            filter: {
                path: '',
                instanceId: '',
                result: null,
                pageSize: 10,
                pageNo: 1
            },
            failedList: [],
            failedVisible: false
        }
    },
    created () {
        localStorage.path = this.$route.path
        localStorage.params = ''
        this.fetchPermission()
        this.fetchNamespace()
        if (this.$route.query.instance) {
            this.filter.path = this.$route.query.instance
            const queryPath = this.$route.query.instance.split('/')
            console.log(queryPath)
            this.path.namespace = queryPath[0] || ''
            this.path.application = queryPath[1] || ''
            listApplication(this.path.namespace, '', 'instance').then(response => {
                this.applicationList = response.data
                if (this.path.application) {
                    this.applicationList.map(item => {
                        if (item.applicationName === this.path.application) {
                            this.path.applicationId = item.id
                        }
                    })
                    this.path.prefixPath = []
                    if (queryPath.length > 1) {
                        for (let i = 2; i <= queryPath.length; i++) {
                            this.path.prefixPath.push(queryPath[i] || '')
                            var parentFullPath = i - 2 ? this.path.prefixPath[0] : ''
                            this.pathList[i - 2] = []
                            for (var j = 1; j < this.path.prefixPath.length && j < i - 2; j++) {
                                parentFullPath += (i - 2 > j && this.path.prefixPath[j]) ? '/' + this.path.prefixPath[j] : ''
                            }
                            const data = {
                                namespace: this.path.namespace,
                                applicationId: this.path.applicationId,
                                parentFullPath: parentFullPath
                            }
                            listPath(data).then(res => {
                                this.pathList[i - 2] = res.data
                                if (this.path.prefixPath[this.path.prefixPath.length - 1] && res.data.length) {
                                    this.path.prefixPath.push('')
                                    this.pathList.push([])
                                }
                            })
                            const { path, instanceId, result, pageSize, pageNo } = this.filter
                            const listData = { path, instanceId, result, pageSize, pageNo }
                            this.loading = true
                            listInstance(listData).then(response => {
                                this.list = response.data
                                this.total = response.total
                                this.loading = false
                            }).catch(() => {
                                this.loading = false
                            })
                        }
                    }
                }
            })
        } else if (this.$route.query.params) {
            this.path = JSON.parse(this.$route.query.params).path
            this.filter.instanceId = JSON.parse(this.$route.query.params).instanceId
            this.filter.result = JSON.parse(this.$route.query.params).result
            this.filter.pageSize = JSON.parse(this.$route.query.params).pageSize
            this.filter.pageNo = JSON.parse(this.$route.query.params).pageNo
            localStorage.namespace = this.path.namespace
            this.fetchApplication()
            this.fetchData()
        }
        // this.fetchData()
    },
    watch: {
        'path.namespace' () {
            if (!this.$route.query.instance) {
                this.setURL()
            }
        },
        'path.applicationId' () {
            if (!this.$route.query.instance) {
                this.setURL()
            }
        },
        'path.prefixPath' () {
            if (!this.$route.query.instance) {
                this.setURL()
            }
        },
        'filter.instanceId' () {
            if (!this.$route.query.instance) {
                this.setURL()
            }
        },
        'filter.result' () {
            if (!this.$route.query.instance) {
                this.setURL()
            }
        },
        'filter.pageSize' () {
            if (!this.$route.query.instance) {
                this.setURL()
            }
        },
        'filter.pageNo' () {
            if (!this.$route.query.instance) {
                this.setURL()
            }
        }
    },
    methods: {
        setURL () {
            const data = {
                path: this.path,
                instanceId: this.filter.instanceId,
                result: this.filter.result,
                pageSize: this.filter.pageSize,
                pageNo: this.filter.pageNo
            }
            var url = `${location.href.split('?params=')[0]}?params=${JSON.stringify(data)}`
            history.pushState({ url: url }, '', url)
            localStorage.params = JSON.stringify(data)
        },
        selectPermission (row, index) {
            return this.permission.manageableResources.indexOf(row.applicationId) > -1 || this.permission.manageableResources.indexOf('*') > -1
        },
        batchPermission () {
            const data = this.list.filter(item => {
                return this.permission.manageableResources.indexOf(item.applicationId) > -1 || this.permission.manageableResources.indexOf('*') > -1
            })
            console.log(data)
            return data.length > 0
        },
        buttonPermission (appId) {
            return this.permission.manageableResources.indexOf(appId) > -1 || this.permission.manageableResources.indexOf('*') > -1
        },
        fetchPermission () {
            getPermission('instance').then(response => {
                this.permission.isSuperAdmin = response.data.isSuperAdmin
                this.permission.isSuperOperator = response.data.isSuperOperator
                response.data.manageableResources.map(item => {
                    const data = item.split('/')
                    const appData = data[0].split(':')[1].split('|')
                    appData.map(app => {
                        this.permission.manageableResources.push(app)
                    })
                })
            })
        },
        fetchNamespace () {
            if (localStorage.namespaceList) {
                this.namespaceList = JSON.parse(localStorage.namespaceList)
            } else {
                listNamespace().then(response => {
                    this.namespaceList = response
                })
            }
        },
        setNamespace (val) {
            if (val) {
                localStorage.namespace = this.path.namespace
                this.fetchApplication()
            }
            this.fetchData()
        },
        fetchApplication () {
            this.path.namespace = localStorage.namespace
            if (this.path.namespace) {
                listApplication(this.path.namespace, '', 'instance').then(response => {
                    this.applicationList = response.data
                    if (this.path.applicationId) {
                        const data = {
                            namespace: this.path.namespace,
                            applicationId: this.path.applicationId,
                            parentFullPath: ''
                        }
                        listPath(data).then(response => {
                            this.pathList = [response.data, []]
                            this.path.prefixPath = ['']
                        })
                    }
                })
            }
        },
        fetchPath (index, prefixPath, applicationId) {
            var path = index ? prefixPath[0] : ''
            this.pathList[index] = []
            for (var i = 1; i < prefixPath.length && i < index; i++) {
                path += (index > i && prefixPath[i]) ? '/' + this.path.prefixPath[i] : ''
            }
            const data = {
                namespace: this.path.namespace,
                applicationId: applicationId,
                parentFullPath: path
            }
            listPath(data).then(response => {
                this.pathList[index] = response.data
                if (this.path.prefixPath[this.path.prefixPath.length - 1] && response.data.length) {
                    this.path.prefixPath.push('')
                    this.pathList.push([])
                }
            })
        },
        handelAppChange () {
            this.path.prefixPath = ['']
            if (this.path.applicationId) {
                this.applicationList.map(item => {
                    if (item.id === this.path.applicationId) {
                        this.path.application = item.applicationName
                    }
                })
                const data = {
                    namespace: this.path.namespace,
                    applicationId: this.path.applicationId,
                    parentFullPath: ''
                }
                listPath(data).then(response => {
                    this.pathList = [response.data, []]
                })
            } else {
                this.path.application = ''
            }
            this.fetchData()
        },
        handlePrefixChange (index, isQuery) {
            console.log(this.path.prefixPath.indexOf(''))
            if (this.path.prefixPath.indexOf('') !== -1) {
                this.path.prefixPath.splice(this.path.prefixPath.indexOf('') + 1)
            }
            console.log(this.path.prefixPath)
            var reg = /[A-Z]/
            if (isQuery || !reg.test(this.path.prefixPath[index])) {
                for (var i = 0; i < this.path.prefixPath.length; i++) {
                    if (index < i) {
                        this.path.prefixPath[i] = ''
                    }
                }
                this.fetchPath(index + 1, this.path.prefixPath, this.path.applicationId)
                this.fetchData()
            } else {
                this.$message({
                    type: 'warning',
                    message: 'Prefix path cannot contain uppercase letters:' + this.path.prefixPath[index]
                })
            }
        },
        fetchData () {
            const { namespace, application, prefixPath } = this.path
            this.filter.path = namespace
            if (application) {
                this.filter.path += '/' + application
                if (prefixPath.length && prefixPath[0]) {
                    prefixPath.map(item => {
                        this.filter.path += '/' + item
                    })
                }
            }
            if (this.filter.path.length && this.filter.path[this.filter.path.length - 1] === '/') {
                this.filter.path = this.filter.path.slice(0, this.filter.path.length - 1)
            }
            console.log(this.filter.path)
            const { path, instanceId, result, pageSize, pageNo } = this.filter
            const data = { path, instanceId, result, pageSize, pageNo }
            // if (path) {
                this.loading = true
                listInstance(data).then(response => {
                    this.list = response.data
                    this.total = response.total
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            // } else {
            //     this.$message({
            //         type: 'warning',
            //         message: 'Please input path'
            //     })
            // }
        },
        handleSelectionChange (val) {
            this.selectedRows = val
        },
        batchRetryInstance () {
            if (this.selectedRows.length) {
                this.$confirm('This will retry the instances. Continue?', 'Warning', {
                    confirmButtonText: 'Retry',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.loading = true
                    var instanceId = []
                    this.selectedRows.map(item => {
                        instanceId.push(item.instanceId)
                    })
                    retryInstance({ instanceId }).then(response => {
                        this.loading = false
                        this.fetchData()
                        if (response.failedList.length) {
                            this.failedList = response.failedList
                            this.failedVisible = true
                        }
                        this.$message({
                            type: response.failedNum ? 'warning' : 'success',
                            message: 'Success:' + response.successNum + ', Failed:' + response.failedNum
                        })
                    }).catch(() => {
                        this.loading = false
                    })
                }).catch(() => {
                    this.loading = false
                    this.$message({
                        type: 'info',
                        message: 'Retry canceled'
                    })
                })
            } else {
                this.$message({
                    type: 'warning',
                    message: 'Please select instances to retry'
                })
            }
        },
        retryInstance (id) {
            this.$confirm('This will retry the instance. Continue?', 'Warning', {
                confirmButtonText: 'Retry',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                const instanceId = [id]
                retryInstance({ instanceId }).then(response => {
                    this.loading = false
                    if (response.failedList.length) {
                        this.failedList = response.failedList
                        this.failedVisible = true
                    }
                    this.$message({
                        type: response.failedNum ? 'warning' : 'success',
                        message: 'Success:' + response.successNum + ', Failed:' + response.failedNum
                    })
                    this.fetchData()
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Retry canceled'
                })
            })
        },
        batchCheckInstance () {
            var instanceId = []
            this.selectedRows.map(item => {
                instanceId.push(item.instanceId)
            })
            checkInstance(instanceId).then(response => {
                this.$message({
                    type: 'success',
                    message: 'success'
                })
            })
        },
        checkInstance (id) {
            const instanceId = [id]
            checkInstance(instanceId).then(response => {
                this.$message({
                    type: 'success',
                    message: 'success'
                })
            })
        },
        batchUnregisterInstance () {
            if (this.selectedRows.length) {
                this.$confirm('This will unregister the instances. Continue?', 'Warning', {
                    confirmButtonText: 'Unregister',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.loading = true
                    var instanceId = []
                    this.selectedRows.map(item => {
                        instanceId.push(item.instanceId)
                    })
                    unregisterInstance({ instanceId }).then(response => {
                        this.loading = false
                        if (response.failedList.length) {
                            this.failedList = response.failedList
                            this.failedVisible = true
                        }
                        this.$message({
                            type: response.failedNum ? 'warning' : 'success',
                            message: 'Success:' + response.successNum + ', Failed:' + response.failedNum
                        })
                        this.fetchData()
                    }).catch(() => {
                        this.loading = false
                    })
                }).catch(() => {
                    this.loading = false
                    this.$message({
                        type: 'info',
                        message: 'Unregister canceled'
                    })
                })
            } else {
                this.$message({
                    type: 'warning',
                    message: 'Please select instances to unregister'
                })
            }
        },
        unregisterInstance (id) {
            this.$confirm('This will unregister the instance. Continue?', 'Warning', {
                confirmButtonText: 'Unregister',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                const instanceId = [id]
                unregisterInstance({ instanceId }).then(response => {
                    this.loading = false
                    if (response.failedList.length) {
                        this.failedList = response.failedList
                        this.failedVisible = true
                    }
                    this.fetchData()
                    this.$message({
                        type: response.failedNum ? 'warning' : 'success',
                        message: 'Success:' + response.successNum + ', Failed:' + response.failedNum
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Unregister canceled'
                })
            })
        },
        handleSizeChange (val) {
            this.filter.pageSize = val
            this.fetchData()
        },
        handleCommand (command) {
            this.filter.result = command
            this.fetchData()
            // return row[property] === value
        }
    }
}
</script>
<style>
.header-table.zm-table .zm-scrollbar {
    display: none;
}
</style>
